window.$ = window.jQuery = require("jquery")
require("jquery-ui/dist/jquery-ui.min")
require("bootstrap/dist/js/bootstrap")

import StripeHelper from './libs/StripeHelper'
window.StripeHelper = StripeHelper

import { Fancybox } from "@fancyapps/ui";

window.Fancybox = Fancybox;

import Vue from "vue"
window.Vue = Vue
Vue.config.silent = true

import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import es from '@fullcalendar/core/locales/es';

window.FullCalendar = {
  Calendar,
  dayGridPlugin,
  interactionPlugin,
  es
};

// import moment from 'moment'
// require('moment-timezone');
// import 'moment/locale/es'
// moment.locale('es')
// window.moment = moment

import dayjs from 'dayjs';
import 'dayjs/locale/es';
dayjs.locale('es');
var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)
window.dayjs = dayjs;
window.moment = dayjs;

import vSelect from 'vue-select'
window.Vue.component('v-select', vSelect)
window.Vue.component('v-select-check', require('../componentes/SelectCheck.vue').default)
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/es';
window.Vue.component('date-picker', DatePicker)
window.Vue.component('paginator', require('../componentes/Paginator').default)
window.Vue.component('google-autocomplete', require('../componentes/GoogleAutocomplete').default);

import { Loader } from "@googlemaps/js-api-loader"
import { MarkerClusterer } from "@googlemaps/markerclusterer";

window.MapaLoader = Loader
window.MarkerClusterer = MarkerClusterer

window.swal = require('sweetalert')

window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
// validar errores AXIOS
window.axios.interceptors.response.use(
  (response) => response,
  (error) => {
    ReportErrorLog(error)
    console.error(error)
    swal({
      icon: "info",
      title: "Ocurrió un error inesperado, por favor revise su conexión a internet",
      button: {
        text: "Aceptar",
        closeModal: true,
      },
    })
    throw error
  }
)

require('./vue/filters')
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

//owl carrusel
require('owl.carousel')
// require('./vendor/owl/js/owl2row')

require('./vendor/js/iconify')
require('./vendor/js/jquery.validate.min')
require('./vendor/js/perfect-scrollbar')
require('./vendor/js/Alerts')

window.MapaStyle =[
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      { "color": "#e9e9e9" },
      { "lightness": 17 }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "geometry",
    "stylers": [
      { "color": "#e9e9e9" },
      { "lightness": 20 }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.fill",
    "stylers": [
      { "color": "#ffffff" },
      { "lightness": 17 }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      { "color": "#ffffff" },
      { "lightness": 29 },
      { "weight": 0.2 }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry",
    "stylers": [
      { "color": "#ffffff" },
      { "lightness": 18 }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry",
    "stylers": [
      { "color": "#ffffff" },
      { "lightness": 16 }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      { "color": "#f5f5f5" },
      { "lightness": 21 }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      { "color": "#dedede" },
      { "lightness": 21 }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      { "visibility": "on" },
      { "color": "#ffffff" },
      { "lightness": 16 }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      { "saturation": 36 },
      { "color": "#333333" },
      { "lightness": 40 }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      { "visibility": "off" }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "geometry",
    "stylers": [
      { "color": "#f2f2f2" },
      { "lightness": 19 }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry.fill",
    "stylers": [
      { "color": "#fefefe" },
      { "lightness": 20 }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry.stroke",
    "stylers": [
      { "color": "#fefefe" },
      { "lightness": 17 },
      { "weight": 1.2 }
    ]
  }
];
